<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputRadio from '@/components(new)/UI/Forms/InputRadio/InputRadio.vue'
import InputCheck from '@/components(new)/UI/Forms/InputCheck/InputCheck.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { opcoesSimNao, opcoesSimNaoNaoSei, opcoesDestinacaoUsoImovel } from '@/libs/constants/praticas/opcoesSelects'
import { mapActions } from 'vuex'

export default {
  components: {
    TitleWithRow,
    InputRadio,
    InputCheck,
    InputSelect,
    Label
  },
  props: {
    cadastro: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      nomeAba: 'Uso do solo',
      opcoesSimNao,
      opcoesSimNaoNaoSei,
      opcoesDestinacaoUsoImovel,
      empresasList: [],
      empresasFornecedorasSelecionadas: []
    }
  },
  created () {
    this.getEmpresasFornecedoras()
    this.empresasFornecedorasSelecionadas = this.usoSolo.empresasFornecedoras?.map((empresa) => empresa.idPessoaJuridica)
    if (this.usoSolo.outrasEmpresasFornecedoras) {
      this.empresasFornecedorasSelecionadas.push('OUTRA')
    }
  },
  computed: {
    usoSolo () {
      return this.cadastro.usoSolo
    }
  },
  methods: {
    ...mapActions({
      findAllEmpresasFornecedoras: 'pessoa/findAllEmpresasFornecedoras'
    }),
    async getEmpresasFornecedoras () {
      const empresas = await this.findAllEmpresasFornecedoras()
      this.empresasList = empresas?.map((empresas) => ({
        id: empresas.idPessoaJuridica,
        nome: empresas.nomeFantasiaRazaoSocial
      }))
      this.empresasList.push({ id: 'OUTRA', nome: 'Outra' })
    },
    containsOption (value, option, model) {
      let contains
      if (!Array.isArray(value)) {
        contains = value === option
      } else {
        contains = value.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.cadastro.usoSolo)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    },
    setEmpresasFornecedoras (values) {
      this.usoSolo.empresasFornecedoras = this.empresasList
        .filter((empresa) => values.includes(empresa.id) && empresa.id !== 'OUTRA')
        ?.map(empresa => ({
          idPessoaJuridica: empresa.id,
          nomeFantasiaRazaoSocial: empresa.nome
        }))
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Dados de uso do solo" />
    <el-row>
      <InputRadio
        :nomeAba="nomeAba" :widthColumn="24"
        label="Possui reserva legal?" :obrigatorio="true"
        :options="opcoesSimNaoNaoSei"
        v-model="usoSolo.possuiReservaLegal"
      />
    </el-row>
    <el-row>
      <InputCheck
        :nomeAba="nomeAba" label="Destinação do imóvel"
        :obrigatorio="true"
        :options="opcoesDestinacaoUsoImovel"
        v-model="usoSolo.destinacoesImovel"
        rulesInput="required"
      />
    </el-row>
    <el-row :gutter="20">
      <InputSelect
        :nomeAba="nomeAba"
        label="O agricultor é fornecedor de alguma empresa?"
        v-model="usoSolo.hasFornecedoras"
        :obrigatorio="true"
        :opcoes="opcoesSimNao"
        :multiSelect="false"
        :widthColumn="12"
        rulesInput="required"
      />
      <InputSelect
        :nomeAba="nomeAba"
        label="Quais empresas fornece?"
        v-model="empresasFornecedorasSelecionadas"
        :obrigatorio="true"
        rulesInput="required"
        :opcoes="empresasList"
        :multiSelect="true"
        :widthColumn="6"
        @input="setEmpresasFornecedoras"
        v-if="containsOption(usoSolo.hasFornecedoras, true, 'empresasFornecedoras')"
      />
      <div v-if="containsOption(empresasFornecedorasSelecionadas, 'OUTRA', 'outrasEmpresasFornecedoras')">
        <validation-provider
          rules="required" v-slot="{ errors }" :name="nomeAba + '/Descreva qual'"
        >
          <el-col :span="6">
            <Label label="Descreva qual" :obrigatorio="true" />
            <el-input
              name="Descreva qual" placeholder="Descreva a outra opção..."
              v-model="usoSolo.outrasEmpresasFornecedoras" :class="{'input erro' : errors.length}"
            />
            <span class="help erro"> {{ errors[0] }}</span>
          </el-col>
        </validation-provider>
      </div>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <Label
          label="Qual a destinação da produção?"
        />
        <el-input
          name="Qual a destinação da produção?"
          v-model="usoSolo.destinacaoProducao"
          placeholdes="Digite a destinação da produção"
        />
      </el-col>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/uso-solo/uso-solo.vue